import React, { FunctionComponent } from 'react';

const ErrorRedirect: FunctionComponent = () => {
  if (typeof window !== 'undefined') {
    window.location.href = `${window.location.protocol}//${window.location.host}/Error-PDV`;
  }
  return <div data-testid="404-not-found" />;
};

export default ErrorRedirect;
